import {useMemo} from 'react';

import {FilterDialogSectionId} from 'filters/features/FilterDialog/types';
import {assertPolicyFilter, isPolicyFilter} from 'filters/types';
import {FilterTopbarItemId} from 'filters/features/FilterTopbar/types';
import {UseTreeData} from 'modules/decisionsNext/hooks/trees/types';

import {createTreeViewSection} from 'filters/features/FilterDialog/sections/TreeViewSection/TreeViewSection';
import {locationTree} from 'utils/geoUtils';
import {useOptimizedTreeViewSelection} from 'filters/features/FilterDialog/sections/TreeViewSection/selections/useOptimizedTreeViewSelection';
import {openFilterDialog} from 'filters';
import {createCounterItem} from 'filters/features/FilterTopbar/items/CounterItem/CounterItem';

import LocationIcon from 'components/icons/location.svg';

const useLocationTree: UseTreeData = () =>
  useMemo(
    () => ({
      treeData: locationTree[0].children,
      treeMap: new Map(locationTree[0].children.map(item => [item.key, item])),
      loading: false,
    }),
    []
  );

export const locationDialogSection = createTreeViewSection({
  id: FilterDialogSectionId.States,
  title: 'Account Location',
  icon: LocationIcon,
  entity: 'States',
  useTreeData: useLocationTree,
  useTreeSelection: useOptimizedTreeViewSelection,
  getValue: filter => {
    assertPolicyFilter(filter);

    return filter.location?.states ?? null;
  },
  onChange: (filter, value) => {
    assertPolicyFilter(filter);

    return {
      ...filter,
      location: value?.length
        ? {
            states: value,
          }
        : undefined,
    };
  },
});

export const locationTopbarItem = createCounterItem({
  id: FilterTopbarItemId.States,
  entity: 'Account Locations',
  getCount: filter => {
    if (!isPolicyFilter(filter)) {
      return;
    }

    return filter?.location?.states?.length;
  },
  onClick: () => openFilterDialog(FilterDialogSectionId.States),
  onReset: filter => {
    assertPolicyFilter(filter);

    return {
      ...filter,
      location: undefined,
    };
  },
});
